export default __webpack_public_path__ + "static/media/Education.de0b07a6.pdf";